import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function IVInfusionsHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1521">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/w9qrDnYt5vyZCGWrCAR33N/IV-Infusion.jpg)'
    }} data-id="element-1522" />
      <div className="absolute inset-0 bg-black/50" data-id="element-1523" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1524">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1525">
          <div className="mb-6" data-id="element-1526">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1527">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1528">
                Treatments
              </a>{' '}
              / Medical
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1529">
            Be EXCELLENT
          </span>

          <h1 className="text-[32px] sm:text-4xl lg:text-[56px] uppercase text-white tracking-tight mb-3 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1530">
            IV INFUSIONS & INJECTIONS
          </h1>

          <p className="text-white text-2xl italic mb-6 opacity-80 font-serif" data-id="element-1531">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-1532">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1533">
              IV infusions and injections for wellness offer a fast and
              effective way to deliver essential nutrients, vitamins and
              antioxidants directly into the bloodstream, boosting energy
              levels, enhancing skin radiance, improving mental clarity and
              strengthening the immune system.
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1534">
              Whether you're looking to reduce inflammation or speed up recovery
              from illness (or hangovers!), Be CLINICAL offers IV infusions &
              injections to address your specific needs.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1535">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}